import React from 'react'
import { Box, Copy, Flex } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import Gift from '../Icons/Gift'
import { TRADENAME } from 'commons/js/constants'

const OfferApplied = () => <Flex mt='1em' backgroundColor='accent10' padding='0.5em' alignItems='center' width='100%'>
    <Box><Gift color='accent'/></Box>
    <Box><Copy as='span' padding='0' ml='0.5em'><FormattedMessage defaultMessage='Precio exclusivo {reason}' values={{
    reason: <Copy as='span' fontWeight='regular'><FormattedMessage defaultMessage='por ser de {tradename}' values={{tradename: TRADENAME}}/></Copy>,
}}/></Copy></Box>
</Flex>

export default OfferApplied
